var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 79,
    viewBox: "0 0 74 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.277 48.1644L73.2868 70.8303L37.277 34.8076L0.429688 70.8303L37.277 48.1644Z",
    fill: "url(#paint0_linear_419_2842)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2868 70.8307H0.429688L37.2763 61.1167L73.2868 70.8307Z",
    fill: "url(#paint1_linear_419_2842)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.277 16.9995L73.2868 70.8312L37.277 0L0.429688 70.8312L37.277 16.9995Z",
    fill: "url(#paint2_linear_419_2842)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 75L7 76.6264L28 78.2527L30.5714 76.6264L28 75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8555 75L67.8555 76.6264L46.8555 78.2527L44.284 76.6264L46.8555 75Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.43909,
    height: 2.43991,
    rx: 0.406593,
    transform: "matrix(-0.744344 -0.667797 0.746348 -0.665556 33.2461 78.2529)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.43909,
    height: 2.43991,
    rx: 0.406593,
    transform: "matrix(-0.744344 -0.667797 0.746348 -0.665556 37.5273 78.2529)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.43909,
    height: 2.43991,
    rx: 0.406593,
    transform: "matrix(-0.744344 -0.667797 0.746348 -0.665556 41.8164 78.2529)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_419_2842",
    x1: 37,
    y1: 15,
    x2: 37,
    y2: 58.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C30280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A2CC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_419_2842",
    x1: 37,
    y1: 57,
    x2: 37,
    y2: 73.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C30280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#052DB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_419_2842",
    x1: 36.8583,
    y1: 6.69388e-9,
    x2: 37,
    y2: 57.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C30280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#811DAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.8bbe005cb47aa0ecd7bda8e83cbbf878.svg";
export { ForwardRef as ReactComponent };